import React from "react";

import { LoadingIcon } from "@packages/ds";
import { Command } from "cmdk";
import { useIntl } from "react-intl";

import { useCommandMenuContext, useSearchDocs } from "../hooks";
import * as S from "../styles";

import { Highlighter } from "./Highlighter";
import { Item } from "./Item";

export function DocsList() {
  const { inputValue } = useCommandMenuContext();
  const { data, isLoading } = useSearchDocs(inputValue);
  const intl = useIntl();

  return (
    <Command.Group heading="Docs">
      {data?.hits?.map((hit, key) => {
        return (
          <Item
            isVertical
            key={key + hit.section + " | " + hit.title}
            value={key + hit.section + " | " + hit.title}
            data-pendo-identifier="result.type.docs"
            onSelect={() =>
              window
                .open(
                  intl.formatMessage({ id: "links.documentation.homepage" }) +
                    hit.url,
                  "_blank",
                  "noopener,noreferrer"
                )
                ?.focus()
            }
          >
            <Highlighter
              searchText={inputValue}
              textToHighlight={hit.section + " | " + hit.title}
            />
            <S.DocDescription>
              <Highlighter searchText={inputValue} textToHighlight={hit.text} />
            </S.DocDescription>
          </Item>
        );
      })}
      {isLoading ? (
        <S.LoaderContainer>
          <Command.Loading>
            <LoadingIcon />
          </Command.Loading>
        </S.LoaderContainer>
      ) : (
        <Command.Empty>
          {intl.formatMessage({ id: "command_k.no_results" })}
        </Command.Empty>
      )}
    </Command.Group>
  );
}
